<template>
  <div class="books-slider">
    <div class="slider-wrapper">
      <div class="slider">
        <router-link
            class="book"
            v-for="(book, index) in books"
            :key="index"
            :to="{ name: 'pages.bookInfo', params: { id: book.id } }"
        >
          <img :src="baseUrl + '/storage/' + book.cover" alt="Cover image">

          <div class="rating">
            <span class="star"></span>
            <span class="star"></span>
            <span class="star"></span>
            <span class="star"></span>
            <span class="star"></span>
          </div>

          <h4>{{ book.name }}</h4>
          <p class="light">Door {{ book.author }}</p>

          <span class="btn">Meer informatie</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {baseUrl} from '@/http/utl.js';

export default {
  name: "BooksSlider",
  props: {
    books: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      baseUrl: baseUrl,
    }
  },
};
</script>
